/**
 * Single source of truth for "which dashboard does this role land on".
 * super_admin and admin each get their own URL prefix — /super-admin/dashboard
 * and /admin/dashboard — even though the pages behind them are identical
 * today (see the shared [adminRole] route and RequireRole). merchant gets
 * its own business-scoped dashboard. Unlisted roles (e.g. a future
 * `customer`) have no dashboard yet, so they route back to the login screen.
 */

const ADMIN_ROLE_SEGMENTS: Record<string, string> = {
    super_admin: "super-admin",
    admin: "admin",
}
const MERCHANT_ROLES = new Set(["merchant"])

export function canAccessAdminDashboard(role: string | undefined | null): boolean {
    return !!role && role in ADMIN_ROLE_SEGMENTS
}

export function canAccessMerchantDashboard(role: string | undefined | null): boolean {
    return !!role && MERCHANT_ROLES.has(role)
}

/** The URL segment ("super-admin" | "admin") a role's own admin dashboard lives under, or null. */
export function getAdminRoleSegment(role: string | undefined | null): string | null {
    return (role && ADMIN_ROLE_SEGMENTS[role]) || null
}

/** Where to send a user right after login, or when they land somewhere their role can't use. */
export function getRoleHomePath(role: string | undefined | null): string {
    const adminSegment = getAdminRoleSegment(role)
    if (adminSegment) return `/${adminSegment}/dashboard`
    if (canAccessMerchantDashboard(role)) return "/merchant/dashboard"
    return "/login"
}
